import * as React from "react";
import Cookies from 'js-cookie';
import i18n from "../../../i18n";
import { store } from '../../../store/index';
import { IInitialState, DataContext, WebChatStatus, WebChatDTO, TicketStatus } from '../../../models/chat.models';
import { webChatService } from '../../../services/webchat.service';

var Color = require('color');

export interface WebChatStartChatProps { }

export const WebChatStartChat = (props: WebChatStartChatProps) => {

  const context: IInitialState = React.useContext(DataContext);

  const cssContent = require('./start-chat.css').toString();
  let personalizedCss = '';

  if (context.webChatSettings && context.webChatSettings.MainColour) {
    const mainColor = Color(context.webChatSettings.MainColour).rgb().string();
    const lighthenMainColor = Color(context.webChatSettings.MainColour).lighten(0.2).rgb().string();
    const lighthen2MainColor = Color(context.webChatSettings.MainColour).lighten(0.3).rgb().string();
    
    personalizedCss = '\
    .help-desk-new-conversation-button {\
      background: linear-gradient(135deg, ' + mainColor + ' 0%, ' + lighthenMainColor + ' 100%); \
    }\
    .help-desk-new-conversation-button:hover {\
      background: linear-gradient(135deg, ' + lighthenMainColor + ' 0%, ' + lighthen2MainColor + ' 100%); \
    }\
    ';
  }

  if (context.webChatSettings && context.webChatSettings.PrimaryTextColour) {

    const alphaPrimaryTextColour = Color(context.webChatSettings.PrimaryTextColour).alpha(0.7).rgb().string();

    personalizedCss = personalizedCss + '\
    .help-desk-start-chat-header {\
      color: ' + context.webChatSettings.PrimaryTextColour + ';\
    }\
    .help-desk-start-chat-message > div {\
      color: ' + alphaPrimaryTextColour + ';\
    }';
  }

  if (context.webChatSettings && context.webChatSettings.SecondaryTextColour) {

    personalizedCss = personalizedCss + '\
    .help-desk-new-conversation-button-content-svg path {\
      fill: ' + context.webChatSettings.SecondaryTextColour + ';\
    }\
    .help-desk-new-conversation-button {\
      color: ' + context.webChatSettings.SecondaryTextColour + ';\
    }';
  }
  
  async function createNewSession() {
      Cookies.remove("wch_session");
      if (context.webChatDto.Ticket && context.webChatDto.Ticket.Id ){
        //await webChatService.unsubscribeFromTicket(context.webChatDto.ticket.id, context.webChatDto.session);
        //await webChatService.unsubscribeFromMessageTicket(context.webChatDto.ticket.id, context.webChatDto.session);
      }
      let webChat: WebChatDTO = await webChatService.getActiveChat('');
      if (webChat) {
        if (webChat.Lang) {
          i18n.changeLanguage(webChat.Lang);
        } else {
          let lang = Cookies.get("lang");
          if (lang) {
            i18n.changeLanguage(lang);
          }
        }
        Cookies.set("wch_session", webChat.Session, { expires: 1 });
        store.dispatch({ type: 'SET_SUBSCRIBE_CHAT', payload: false });
        store.dispatch({ type: 'SET_WEB_CHAT', payload: webChat });
        store.dispatch({ type: 'SHOW_WELCOME_MESSAGE', payload: !webChat.ForceOpen });
        store.dispatch({ type: 'SET_WEB_CHAT_MESSAGES', payload: webChat.Ticket && webChat.Ticket && webChat.Ticket.TicketResponseMessages ? webChat.Ticket.TicketResponseMessages : [] });
        store.dispatch({ type: 'SHOW_CHAT_VIEW' });
      }
  }

  async function showChatConversationView() {
    if (context.webChatDto && context.webChatDto.Session && (context.webChatDto.Status == WebChatStatus.New || context.webChatDto.Status == WebChatStatus.Active)) {
      if (context.webChatDto.Ticket && context.webChatDto.Ticket.Id && context.webChatDto.Ticket.Status == TicketStatus.Closed) {
        await createNewSession();
      } else {
        // No action needed for existing sessions
      }
      if(!context.subscribedChat
         && context.webChatDto.Ticket && context.webChatDto.Ticket.Id && context.webChatDto.Ticket.Status != TicketStatus.Closed) {
        store.dispatch({ type: 'SET_SUBSCRIBE_CHAT', payload: true });
      }
      store.dispatch({ type: 'SHOW_CHAT_VIEW' });
    } else {
      await createNewSession();
    }
  }

  async function showVoiceChatView() {
    store.dispatch({ type: 'SHOW_VOICE_CHAT_VIEW' });
  }

  if (context.webChatDto && context.webChatDto.ForceOpen) {
    setTimeout(async function() {
      try {
        await showChatConversationView();
      } catch(ex) {
      } finally {
      }
    }, 0);
  }

  return (
    <div className="help-desk-start-chat-body">
      <style>
        {cssContent}
        {personalizedCss}
      </style>
      <div className="help-desk-start-chat">
        <div className="help-desk-start-chat-header">
          {webChatService.getTranslations(3, context.webChatSettings)}
        </div>
        <div className="help-desk-start-chat-message">
          <div>
            {webChatService.getTranslations(4, context.webChatSettings)}
          </div>
        </div>
        <div className="help-desk-start-content">
          <button className="help-desk-new-conversation-button button-margin" onClick={() => showChatConversationView()}>
            <div className="help-desk-new-conversation-button-content">
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" className="help-desk-new-conversation-button-content-svg" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 448l416-192L48 64v149.333L346 256 48 298.667z"></path>
              </svg>
              <span>
                {context.webChatDto && context.webChatDto.Ticket && context.webChatDto.Ticket.Status != TicketStatus.Closed
                   && context.webChatDto.Status == WebChatStatus.Active ? webChatService.getTranslations(6, context.webChatSettings) : webChatService.getTranslations(5, context.webChatSettings)}
              </span>
            </div>
          </button>
          {context.webChatSettings && context.webChatSettings.IsVoiceChatEnabled && (
            <button className="help-desk-new-conversation-button button-margin" onClick={() => showVoiceChatView()}>
              <div className="help-desk-new-conversation-button-content">
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" className="help-desk-new-conversation-button-content-svg" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path d="M48 448l416-192L48 64v149.333L346 256 48 298.667z"></path>
                </svg>
                <span>
                  Voice chat
                </span>
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}